import React, { Component } from "react";
import "./designView.less";
import { meshLog, SPGet } from "../../../utils/spUtils";
import montion from "../../../imgs/item/montion.png";
import emergency from "../../../imgs/item/emergency.png";
import map_btn from "../../../imgs/btn/map_btn.png";
import PubSub from 'pubsub-js';
import { Rnd } from "react-rnd";
import { Design_Upload_Map, Device_Map_Click, Group_Map_Click } from "../../../const/infoConst";
import { getMapColor, sortMapGroupArr, updateMapDevicexy, updateMapGroupColor, updateMapGroupWidthHeight, updateMapGroupxy } from "../../../utils/meshUtils";
import { IsEmergencyDevice } from "../../../utils/pidUtils";

let mId=-1;
let netImg="";
export default class DesignView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list:[],
      customImg:"", //布点图
      drapGroup:true, //是否拖动组

      //选颜色相关
      colorShow:false,
      colorTop:0,
      colorLeft:0,
      colorSet:0,  //颜色色彩

    };
  }

  componentDidMount() {
    // meshLog("加载布点图");
    this.updateMapGroupList(-1,""); 
    netImg=SPGet("mapImage");
    this.loadCustomDesignImg(); 
    PubSub.subscribe('changeMeshUpdateUI', (msg, data) => { //切换mesh
        this.updateMapGroupList(-1,""); 
    })
    PubSub.subscribe(Group_Map_Click, (msg, data) => {
        // meshLog("布点图 Group:",msg,data);
        this.updateMapGroupList(data.groupID,"");  
    })
    PubSub.subscribe(Device_Map_Click, (msg, data) => {
        // meshLog("布点图 Device:",msg,data);
        this.updateMapGroupList(mId,data);
        this.setState({
          drapGroup:false,
        });
    })
    PubSub.subscribe(Design_Upload_Map, (msg, data) => {
        netImg=data;
        this.loadCustomDesignImg();
    })
  }

  //加载用户自定义布点图
  loadCustomDesignImg(){
    meshLog("加载布点图:",netImg);
    this.setState({
        customImg:netImg.length>0?netImg:"",
    });
  }

  //获取数据库的结果
  updateMapGroupList(groupID,deviceMac) {
    mId=groupID;
    let arr=sortMapGroupArr(groupID,deviceMac);
    meshLog("map 布点图0-",arr);
    if(groupID==-1){
      arr[arr.length]={"id":-1,"name":"","width": 1, "height": 1, "x": 1, "y": 1, "color":"#00000000","devices":[]};
    }else if(arr.length>0){
      arr[arr.length-1].isEdit=true;
      this.setState({
        colorShow:false,
        colorSet:arr[arr.length-1].color,
      });
      this.judgeMapXy(arr[arr.length-1]);
    }
    // meshLog("map 布点图1-",arr);
    this.setState({
      list:arr,
      drapGroup:true,
    });
  } 

  //---------------------------------group---------------------------------
  groupMoveStart(){
    meshLog("开始拖拽");
  }

  groupMoving(e, d){
    meshLog("group 拖拽中");
  }

  groupMoveStop=(e, d)=>{ //, e, d
    meshLog("拖拽结束",e,d);
    let arr=this.state.list;
    //自动对齐
    let autoX=d.x;
    let autoY=d.y;
    for(let i=0;i<arr.length;i++){
      if(arr[i].id!=mId){
        if(autoX>(arr[i].x-10) && autoX<(arr[i].x+10)){
          autoX=arr[i].x;
        }
        if(autoY>(arr[i].y-10) && autoY<(arr[i].y+10)){
          autoY=arr[i].y;
        }
      }
    }
    //布局
    for(let i=0;i<arr.length;i++){
      if(arr[i].id==mId){
        arr[i].x=autoX;
        arr[i].y=autoY;
      }
    }
    updateMapGroupxy(mId,autoX,autoY);
    this.judgeMapXy(arr[arr.length-1]);
    this.setState({
      list:arr,
    });
  }

  moveResizeStop=(e, direction, ref, delta, position)=>{ 
    meshLog("调整大小",position.x,position.y);
    meshLog("调整大小",ref.style.width,ref.style.height);
    let arr=this.state.list;
    let mWidth=parseInt((ref.style.width).replace("px", ""));
    let mHeight=parseInt((ref.style.height).replace("px", ""))
    //自动宽高
    let autoW=mWidth;
    let autoH=mHeight;
    for(let i=0;i<arr.length;i++){
      if(i<arr.length-1){
        if(autoW>(arr[i].width-10) && autoW<(arr[i].width+10)){
          autoW=arr[i].width;
        }
        if(autoH>(arr[i].height-10) && autoH<(arr[i].height+10)){
          autoH=arr[i].height;
        }
      }
    }
    //布局
    for(let i=0;i<arr.length;i++){
      if(i==arr.length-1){
          arr[i].width=autoW;
          arr[i].height=autoH;
          arr[i].x=position.x;
          arr[i].y=position.y;
      }
      let devices=arr[i].devices;
      for(let j=0;j<devices.length;j++){
          if(devices[j].x>autoW-20){
              devices[j].x=autoW-25;
          }
          if(devices[j].y>autoH-20){
              devices[j].y=autoH-25;
          }
      }
    }
    updateMapGroupWidthHeight(mId,mWidth,mHeight,position.x,position.y);
    this.judgeMapXy(arr[arr.length-1]);
    this.setState({
      list:arr,
    })
  }

  //---------------------------------device---------------------------------
  deviceMoveStart(){
    meshLog("开始拖拽");
  }

  deviceMoving(e, d){
    meshLog("device 拖拽中");
  }

  deviceMoveStop=(e, d)=>{ //, e, d
    meshLog("拖拽结束",e,d);
    let arr=this.state.list;
    let mac="";
    //自动对齐
    let autoX=d.x;
    let autoY=d.y;
    for(let i=0;i<arr.length;i++){
      if(arr[i].id==mId){
        let devices=arr[i].devices;
        for(let j=0;j<devices.length;j++){
          if(devices[j].id!=e){
            if(autoX>(devices[j].x-10) && autoX<(devices[j].x+10)){
              autoX=devices[j].x;
            }
            if(autoY>(devices[j].y-10) && autoY<(devices[j].y+10)){
              autoY=devices[j].y;
            }
          }
        }
      }
    }
    //布局
    for(let i=0;i<arr.length;i++){
      if(arr[i].id==mId){
        let devices=arr[i].devices;
        for(let j=0;j<devices.length;j++){
          if(devices[j].id==e){
            mac=devices[j].mac;
            devices[j].x=autoX;
            devices[j].y=autoY;
          }
        }
      }
    }
    if(mac.length>0){
        updateMapDevicexy(mId,mac,autoX,autoY);
    }
    this.setState({
      list:arr,
    });
  }

  //---------------------------------变更group颜色---------------------------------

  //颜色弹窗
  mapBtnClick(){
    this.setState({
      colorShow:true,
    });
  }
  //更新弹窗位置
  judgeMapXy(item){
    let mx=item.x+item.width+6;
    let my=item.y+5;
    meshLog("map color",mx,my);
    this.setState({
        colorTop:my,
        colorLeft:mx,
    });
  }
  //切换颜色
  colorBtnClick(item){
    meshLog("colorBtnClick:",item);
    this.setState({
      colorSet:item,
    });
  }

  //关闭弹窗
  closeBtnClick(){
    this.setState({
      colorShow:false,
    });
  }

  //保存
  saveBtnClick(){
    let arr=this.state.list;
    for(let i=0;i<arr.length;i++){
      if(arr[i].id==mId){
        arr[i].color=getMapColor(this.state.colorSet);
      }
    }
    updateMapGroupColor(mId,this.state.colorSet);
    this.setState({
      list:arr,
      colorShow:false,
    });
  }


  
  

  render() {
    const { drapGroup, colorShow, colorTop, colorLeft, colorSet} = this.state;

    return (
      <div className="design_container">
        <div className="map-image" style={{background:"#ffffff",borderRadius:"5px"}}></div>
        <img className="map-image" style={{ visibility: this.state.customImg.length>0 ? "visible" : "hidden" }} src={this.state.customImg}  draggable="false"/>
        <div className="map_group_list">
            {this.state.list.map((item) => (
              <div className="map_group_item" key={item.id}>
                <Rnd className="group_drop" size={{width:item.width+"px", height:item.height+"px"}}  position={{x:item.x,y:item.y}} bounds="parent" 
                    minWidth={50} minHeight={50} maxWidth={1340} maxHeight={840} style={{background:item.color, border:item.id>0?"1px solid #007bff":"0px solid #007bff"}} 
                    onDragStart={this.groupMoveStart} onDrag={this.groupMoving} onDragStop={(e, data)=>this.groupMoveStop(item.id, data)}
                    onResizeStop={this.moveResizeStop} 
                    enableResizing={drapGroup?true:false} disableDragging={drapGroup?false:true}>
                    <div className="name" style={{marginLeft:(item.width/2-30)+"px",marginTop:(item.height/2-8)+"px", visibility:item.id>0?"visible":"hidden"}}>
                        <span>{item.name}</span>
                    </div>
                    {/* 内部device */}
                    {item.devices.map((device) => (
                      <div className="device_item" key={device.mac} >
                          <Rnd className="device_drop" size={{width:"20px", height:"20px"}}  position={{x:device.x,y:device.y}} bounds="parent" 
                            onDragStart={this.deviceMoveStart} onDrag={this.deviceMoving} onDragStop={(e, data)=>this.deviceMoveStop(device.id, data)}
                            enableResizing={false} disableDragging={drapGroup?true:false}>
                              <div className='device_bg' style={{background:device.color, border:device.color=="#ffffff"?"1px solid #007bff":"0px solid #007bff"}}>
                                  <img className='device_icon' src={IsEmergencyDevice(device.pid)?emergency:montion} draggable="false"/>
                              </div>
                          </Rnd>  
                      </div>
                        
                    ))}
                    {/* 编辑按钮 */}
                    <img className='map_edit_btn' style={{visibility:item.isEdit?"visible" : "hidden"}}  src={map_btn} onClick={() => { this.mapBtnClick() }}/>
                </Rnd>
              </div>                
            ))}
        </div>  
        {/* 选颜色相关 */}
        <div className="map_grey_bg" style={{visibility:colorShow?"visible" : "hidden"}}/>
        <div className="map_color_bg" style={{visibility:colorShow?"visible" : "hidden" ,top:colorTop+"px",left:colorLeft+"px"}}>
            <div className="map_top_title">
                <img className='icon' src={montion}/>
                <span>Group Edit</span>
            </div>
            <span className="color_title">Color Select</span>
            <div className="color_bg">
                <div className="color1" style={{border:colorSet==1?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(1) }}/>
                <div className="color2" style={{border:colorSet==2?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(2) }}/>
                <div className="color3" style={{border:colorSet==3?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(3) }}/>
                <div className="color4" style={{border:colorSet==4?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(4) }}/>
                <div className="color5" style={{border:colorSet==5?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(5) }}/>
                <div className="color6" style={{border:colorSet==6?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(6) }}/>
                <div className="color7" style={{border:colorSet==7?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(7) }}/>
                <div className="color8" style={{border:colorSet==8?"1px solid #007bff":"0px solid #007bff"}} onClick={() => { this.colorBtnClick(8) }}/>
            </div> 
            {/* 底部按钮 */}
            <div className="color-footer">
                <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                <button className='okBtn' onClick={() => { this.saveBtnClick() }}>Confirm</button>
            </div>
        </div>  
        
      </div>
    );
  }
}